import { useEffect } from 'react'
import { trackEvent } from '@fs/zion-analytics'
import { useFeatureFlag } from '@fs/zion-flags'

/**
 * A hook to send analytics data after we fetch data and have the collection Id
 * @param {String} collectionId - The id of the collection this image is in
 * @param {String} ark - The ark for the current image being viewed
 * @returns null
 */
export default function useTrackCollectionView(collectionId, ark) {
  const collectionTrackingFlag = useFeatureFlag('rip_sharedImageViewer_collectionTracking')
  // Send an analytics event when ever we change images as long as we have a collectionId
  useEffect(() => {
    if (collectionId && ark && collectionTrackingFlag.isOn) {
      trackEvent({
        link_name: 'View Image',
        event_name: 'collection_image_view',
        list_type: 'Collections - Collection Image View',
        record_collectionIds: [collectionId],
      })
    }
  }, [collectionId, ark, collectionTrackingFlag.isOn])
}
